var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7814 11.8902L13.0786 9.95294H11.2198V8.69633C11.2198 8.1662 11.479 7.64915 12.3115 7.64915H13.1571V5.99985C13.1571 5.99985 12.3901 5.86896 11.657 5.86896C10.1255 5.86896 9.12549 6.79702 9.12549 8.47642V9.95294H7.42383V11.8902H9.12549V16.5737C9.46713 16.6274 9.81662 16.6549 10.1727 16.6549C10.5287 16.6549 10.8782 16.6274 11.2198 16.5737V11.8902H12.7814Z",
    fill: "#ced3df"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.611328,
    y: 1.45056,
    width: 19.3609,
    height: 19.3609,
    rx: 9.68044,
    stroke: "#ced3df"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.b0dd2dbef982b68ce3f794b6ea76922b.svg";
export { ForwardRef as ReactComponent };